import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { KeycloakAuthorizationService } from "../../../modules/keycloak-authz-angular/services/keycloak-authorization.service";
import { KeycloakAuthzAuthGuard } from "../../../modules/keycloak-authz-angular/services/keycloak-authz-auth-guard";
import { AuthService } from "./_services/auth.service";
import { DeviceRoutingService } from '../../services/device-routing.service';

@Injectable({ providedIn: "root" })
export class AuthGuard extends KeycloakAuthzAuthGuard {
  constructor(
    protected router: Router,
    protected keycloakAngular: KeycloakService,
    protected keycloakAuth: KeycloakAuthorizationService,
    protected readonly authService: AuthService,
    private deviceRoutingService: DeviceRoutingService
  ) {
    super(router, keycloakAngular, keycloakAuth);
  }

  isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      if (!this.authenticated) {
        this.keycloakAngular.login();
        return;
      }

      const requiredRoles: string[] = route.data.roles;
      const requiredPermissions = route.data.permissions;

      // Role-based check (simpler, uses Keycloak realm/client roles)
      if (requiredRoles && requiredRoles.length > 0) {
        const hasRole = requiredRoles.some(role =>
          this.keycloakAngular.isUserInRole(role)
        );
        if (!hasRole) this.deviceRoutingService.redirectToDefaultRoute();
        this.authService.fetchAndSetUser();
        return resolve(hasRole);
      }

      // Resource-based check (legacy UMA authorization)
      if (!requiredPermissions || requiredPermissions.length === 0) {
        return resolve(true);
      } else {
        if (!this.permissions || this.permissions.length === 0) {
          this.deviceRoutingService.redirectToDefaultRoute();
          resolve(false);
        }

        let granted: boolean = false;
        for (const requiredPermission of requiredPermissions) {
          if (this.keycloakAuth.checkAuthorization(requiredPermission)) {
            granted = true;
            break;
          }
        }
        if (!granted) this.deviceRoutingService.redirectToDefaultRoute();

        this.authService.fetchAndSetUser();

        resolve(granted);
      }
    });
  }
}
